import { useEffect, useState } from 'react';
import api from '../services/api';

/**
 * I ruoli del gestionale, letti dal server e MAI scritti qui.
 *
 * Fino al 21 settembre 2026 tre schermate avevano il loro elenco a mano
 * - Gestione utenti, Compiti, Promemoria - e `medico_senior` mancava in
 * due: il filtro non lo trovava, e i promemoria di reparto non gli
 * arrivavano. La fonte e' config/ruoli.js nel backend, verificata
 * all'avvio contro il vincolo del database; qui si legge una volta per
 * sessione e si tiene in memoria.
 *
 * `ruoli` e' l'elenco completo, per filtri ed etichette.
 * `assegnabili` e' cio' che CHI E' COLLEGATO puo' assegnare creando un
 * utente: e' una politica, non un elenco di ruoli, e resta separata.
 */
let cache = null;
let inCorso = null;

export async function caricaRuoli() {
    if (cache) return cache;
    if (!inCorso) {
        inCorso = api.get('/ruoli').then((r) => {
            cache = r.data.data;
            return cache;
        }).finally(() => { inCorso = null; });
    }
    return inCorso;
}

export function useRuoli() {
    const [dati, setDati] = useState(cache || { ruoli: [], assegnabili: [] });
    useEffect(() => {
        let vivo = true;
        caricaRuoli().then((d) => { if (vivo) setDati(d); }).catch(() => { /* filtri vuoti, ma la pagina vive */ });
        return () => { vivo = false; };
    }, []);
    return dati;
}

/* Un elenco che non e' un elenco (una risposta di /api/ruoli senza i
   ruoli) vale come un elenco vuoto: si scrive il valore. Dal 2/10/2026 la
   chiama il menu di ogni schermata (il ruolo dell'utente, in fondo), e
   un'etichetta non deve poter spegnere il guscio. */
export const etichettaRuolo = (ruoli, valore) =>
    ((Array.isArray(ruoli) ? ruoli : []).find((r) => r.valore === valore) || {}).etichetta || valore;
